interface IIntlDateFormat {
    (dateTime?: string | number | Date, isoCode?: string | string[], options?: Intl.DateTimeFormatOptions): string;
}

const _defaultISOCode = navigator.language || 'en-US';

export const momentFormat = 'L';

export const formatStandardDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(d);
}

export const formatFullDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { dateStyle: 'full' }).format(d);
}

export const formatLongDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { dateStyle: 'long' }).format(d);
}

export const formatMediumDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { dateStyle: 'medium' }).format(d);
}

export const formatShortDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { dateStyle: 'short' }).format(d);
}

export const formatFullTime: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { timeStyle: 'full' }).format(d);
}

export const formatLongTime: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { timeStyle: 'long' }).format(d);
}

export const formatMediumTime: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { timeStyle: 'medium' }).format(d);
}

export const formatShortTime: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, { timeStyle: 'short' }).format(d);
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat

export const formatCustomDate: IIntlDateFormat = (dateTime, isoCode = _defaultISOCode, options = { dateStyle: 'full' }) => {
    if (!dateTime) {
        return '';
    }

    const d = new Date(dateTime);

    return new Intl.DateTimeFormat(isoCode, options).format(d);
}